module.exports = __webpack_public_path__ + "static/casper-5fd4346917fc96a1e478b204765d9868.png";